import { lazy } from 'react';

const CharityRGSEAAQuestionRoute = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityRGSEAAQuestion" */ '../components/steps/rgseaa-question-step/RGSEAAQuestion'
    ),
);

export default CharityRGSEAAQuestionRoute;
